<template>
  <gj-modal
    :visible.sync="modalVisible"
  >
    <template #header>详情</template>
    <template #content>
      <div style="padding: 10px">
        <div class="gj-mb10">
          <el-row>
            <el-col :span="2">
              <gj-image src="https://m.media-amazon.com/images/I/31ilDLL+4LL._SL75_.jpg" size="80"></gj-image>
            </el-col>
            <el-col :span="22">
              <div class="gj-mb10">
                <gj-text style="font-size: 12px; color: #444">Waxing Kit Wax Warmer, iBealous Wax Warmer with 4 Bags Painless Hard Wax Beans Hair Removal Kit with Digital Display to Easy Use</gj-text>
              </div>
              <el-row class="gj-mb10">
                <el-col :span="8">
                  <span class="label">店铺/国家</span>
                  <span class="value">积加ERP:US</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">ASIN</span>
                  <span class="value">B0716CCC5D</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">MSKU</span>
                  <span class="value">C5281859-BCCF-11E9</span>
                </el-col>
              </el-row>
              <div>
                <span class="label">促销编码数量</span>
                <span class="value">2</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <app-filter-group :reset="false" :query="false">
            <gj-select
                v-model="promotionCode"
                placeholder="全部促销编码"
                width="150px"
            ></gj-select>
            <gj-date-picker
                v-model="date"
                type="daterange"
            ></gj-date-picker>
          </app-filter-group>
        </div>

        <div>
          <gj-table
            :data="data"
            :columns="columns"
            :offset-height="42"
          >

          </gj-table>
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../minxins";

    export default {
        name: "promotion-analysis-detail",
        mixins: [modalMixIn],
        data() {
            return {
                promotionCode: null,
                date: [],
                data: [{}],
                columns: [
                    {id: 'promotionCode', header: '促销编码', field: 'promotionCode', minWidth: '120px',},
                    {id: 'promotionCode1', header: '促销订单量', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode2', header: '促销销量', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode3', header: '促销销售额', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode4', header: '促销折扣', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode5', header: '退货量', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode6', header: '退货率', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode7', header: '退款量', field: 'promotionCode', minWidth: '120px', align: 'right',},
                    {id: 'promotionCode8', header: '退款率', field: 'promotionCode', minWidth: '120px', align: 'right',},
                ],
            }
        }
    }
</script>

<style scoped>
  .label {
    font-size: 12px;
    color: #666;
    display: inline-block;
    margin-right: 10px;
  }
  .value {
    font-size: 12px;
    color: #333;
  }
</style>
